@import "../../../../../constants";

.finding-status-logo-wrapper {
  display: flex;
  align-items: center;
  width: 100%;

  .finding-status-logo {
    border-radius: 50%;
    color: var(--finding-icon-color);
    text-align: center;
    line-height: 20px;
    height: 20px;
    width: 20px;
    flex: 0 0 20px;
    font-size: var(--font-size-xxs);
    .seem-icon {
      line-height: 20px;
      font-size: var(--font-size-xxs);
    }
    &.finding-status-logo-open {
      background-color: var(--finding-open-bg);
    }
    &.finding-status-logo-ignored {
      background-color: var(--finding-ignored-bg);
    }
    &.finding-status-logo-fixed {
      background-color: var(--finding-fixed-bg);
    }
  }

  .finding-status-label {
    font-size: var(--font-size-s);
    padding-left: var(--spacing-2);
    @include ellipsis(100%);
  }
}
.select__control--is-disabled {
  .finding-status-logo {
    opacity: 0.7;
  }
}
